/**
 * 都道府県を選択するためのモーダルコンポーネントです。
 * @param {IPrefecturesPickModalProps} props - コンポーネントのプロパティ。
 * @returns {React.FC<IPrefecturesPickModalProps>} PrefecturesPickModal コンポーネント。
 */
import React, { useEffect } from "react";
import TkModalWithTitle from "../../../../atoms/TkModalWithTitle";
import { IPrefecturesPickModalProps } from "../../../../../type/componentsType/TkPrefecturesPick";
import {
  Prefectures,
  japanRegions,
} from "../../../../../assets/data/Constants";
import TkTitle from "../../../../atoms/TkTitle";
import { Box } from "@mui/material";
import TkCheckbox from "../../../../atoms/TkCheckbox";
import "./_style.scss";

const PrefecturesPickModal: React.FC<IPrefecturesPickModalProps> = (props) => {
  const { open, onSuccessful, onCancel, selectedPrefecture } = props;

  const [checked, setChecked] = React.useState<string[]>([]);

  type PrefectureKeys = keyof typeof Prefectures;
  const handleChange =
    (prefecture: PrefectureKeys) =>
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        setChecked([...checked, Prefectures[prefecture]]);
      } else {
        setChecked(checked.filter((item) => item !== Prefectures[prefecture]));
      }
    };

  const handleSave = () => {
    onSuccessful && onSuccessful(checked);
  };

  useEffect(() => {
    setChecked(selectedPrefecture);
  }, [selectedPrefecture]);

  return (
    <TkModalWithTitle
      open={open}
      useTopButton
      onClose={onCancel}
      onSave={handleSave}
      saveButtonDisabled={checked.length === 0}
      clearSaveData={() => setChecked([])}
      className="ModalInprefecturesPickModal"
      saveButtonName="選択して閉じる"
      cancelButtonName="キャンセル"
      title="都道府県を選択してください"
    >
      <Box className="prefecturesPickModal">
        {japanRegions.map((item) => {
          return (
            <React.Fragment key={item.region}>
              <TkTitle size="medium" className="title">
                {item.region}
              </TkTitle>

              <Box>
                {item.prefectures.map((prefecture) => {
                  return (
                    <React.Fragment key={prefecture}>
                      <TkCheckbox
                        checked={checked.includes(
                          Prefectures[prefecture as PrefectureKeys]
                        )}
                        onChange={handleChange(prefecture as PrefectureKeys)}
                        label={prefecture}
                        value={prefecture}
                      ></TkCheckbox>
                    </React.Fragment>
                  );
                })}
              </Box>
            </React.Fragment>
          );
        })}
      </Box>
    </TkModalWithTitle>
  );
};

export default PrefecturesPickModal;
